import { addDays, format, subDays, formatDate as fnsFormatDate } from "date-fns";
import { DEFAULT_30_DAY_EXPIRATION } from "../app.constants";

export type DateFormat = "yyyy/MM/dd" | "yyyy-MM-dd" | "yyyyMMdd";

export function getFormatedExpirationDate(dateFormat: DateFormat = "yyyy/MM/dd") {
  const expirationDate = getExpirationDate();
  return format(expirationDate, dateFormat);
}

export function getExpirationDate() {
  const date = new Date();
  return addDays(date, DEFAULT_30_DAY_EXPIRATION);
}

export function removeDays(date: Date, days: number) {
  return subDays(date, days);
}

export function formatDate(date: Date, format: DateFormat) {
  return fnsFormatDate(date, format);
}
